import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, Button } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

export default function ChartArea(props) {
  const selectedValue = { AREA_CODE: props.chart_area };

  return (
    <Box mt={0} width="100%" align="center" key={"chart_area_box"}>
      <h2 className="sectionTitle center">Chart Area</h2>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        key={"chart_area_grid"}
      >
        <Grid item xs={12} md="auto" key={"chart_area_item"}>
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            key={"chart_area_item_box"}
          >
            {props.chart_preference.map((chart_area) => (
              <Box m={0.5} key={"chart_area_box_" + chart_area}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="form-input"
                  data-new-value={chart_area}
                  data-field={"chart_area"}
                  size="large"
                  onClick={(e) =>
                    props.handleGearPreferenceChange(e, chart_area)
                  }
                  id={chart_area}
                  key={chart_area}
                >
                  {chart_area}
                </Button>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item key={"chart_area_field_item"}>
          <Autocomplete
            id="chart_area_auto_complete"
            key={"chart_area_auto"}
            options={props.chartAreaOptions}
            getOptionLabel={(option) => option.AREA_CODE}
            sx={{ maxWidth: 350, minWidth: 250, textAlign: "center" }}
            onChange={props.changeHandler}
            value={selectedValue}
            name={"chart_area"}
            isOptionEqualToValue={(option) => option.AREA_CODE}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chart Area"
                variant="standard"
                helperText={"Select Chart Area"}
              />
            )}
          />
        </Grid>
        <Grid item key={"chart_area_help_item"}>
          <HelpText helpText={getHelpText(props.helpText, "chart_area")} />
        </Grid>
      </Grid>
    </Box>
  );
}
